module.exports = require('./helpers/bundle-url').getBundleURL('4SxJc') + "editor.worker.df298274.js";